import { createApp } from 'vue';
import useElementPlus from '@/utils/useElementPlus';
import useVxeTable from '@/utils/useVxeTable';

import App from './App.vue';
import store from './store';
import router from './router';
import './style/reset.scss';
import './style/themeColor.scss';
import './style/element.scss';
import './style/animation.scss';
// 刷新页面时 先注册已缓存的路由再进行跳转
store.dispatch('router/addRoutes');

const app = createApp(App);
app.use(store).use(router).use(useElementPlus).use(useVxeTable).mount('#app');
